import { useEffect, useState } from 'react'
import { Link } from 'react-router'
import { listImports } from './api'
import type { ImportBatchSummary } from './types'

function formatDateTime(value: string): string {
  return new Date(value).toLocaleString('nl-NL', { dateStyle: 'short', timeStyle: 'short' })
}

/** De laatste imports (spec-63 E6), each linking to its result page (report, undo). */
export function ImportHistory() {
  const [items, setItems] = useState<ImportBatchSummary[] | null>(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let cancelled = false
    listImports()
      .then((list) => {
        if (!cancelled) setItems(list)
      })
      .catch(() => {
        if (!cancelled) setFailed(true)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <section className="vonk-card flex flex-col gap-2 p-4" aria-labelledby="import-history">
      <h2 id="import-history" className="text-base font-semibold text-foreground">
        Recente imports
      </h2>
      {failed ? <p className="text-sm text-danger">Kon de imports niet laden.</p> : null}
      {items === null && !failed ? <p className="text-sm text-muted-foreground">Laden…</p> : null}
      {items?.length === 0 ? <p className="text-sm text-muted-foreground">Nog geen imports.</p> : null}
      {items && items.length > 0 ? (
        <ul className="flex flex-col divide-y divide-border text-sm">
          {items.map((item) => (
            <li key={item.id} className="flex flex-wrap items-center justify-between gap-2 py-2">
              <Link
                to={`/relaties/importeren/${item.id}`}
                className="font-semibold text-primary underline underline-offset-2"
              >
                {item.filename}
              </Link>
              <span className="text-muted-foreground">
                {item.mode === 'contacten' ? 'Contacten' : 'Organisaties'} · {formatDateTime(item.created_at)} ·{' '}
                {item.created_by_name ?? 'Onbekend'} · {item.counts.rows ?? 0} rijen · {item.counts.created ?? 0}{' '}
                aangemaakt
                {item.undone_at ? ' · ongedaan gemaakt' : ''}
              </span>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  )
}
